import { jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { useColorPicker } from "../hooks/useColorPicker.js";
import { NO_COLOR } from "../constants.js";
import { Picker } from "./Picker/Picker.js";
function AddColorToPalette(props) {
  const { group, ...pickerProps } = props;
  const { onAddColor, onDiscardLocalChanges, onChange: onColorPickerChange, value, goToPalette } = useColorPicker();
  const onChange = useCallback(
    (value2) => {
      onColorPickerChange(null, value2);
    },
    [onColorPickerChange]
  );
  const onCommit = useCallback(() => {
    if (value === NO_COLOR) {
      console.error("NO_COLOR cannot be added");
      return;
    }
    onAddColor?.(value, group);
    goToPalette();
  }, [onAddColor, value, group, goToPalette]);
  const onCancel = useCallback(() => {
    onDiscardLocalChanges();
    goToPalette();
  }, [onDiscardLocalChanges, goToPalette]);
  return /* @__PURE__ */ jsx(Picker, { ...pickerProps, onChange, color: value, onCancel, onCommit });
}
export {
  AddColorToPalette
};
//# sourceMappingURL=AddColorToPalette.js.map
